// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
import { LitElement } from 'lit';

export * from './shared-styles.js';
export * from './styles.scss.js';

LitElement.disableWarning?.('change-in-update');